'use client';

import { asText, Content } from '@prismicio/client';

// Components
import { RichTextDefault } from '@/components/RichText/RichTextDefault';

type WithQuoteProps = {
  slice: Content.RegionSliceWithQuote;
};

export const WithQuote = ({ slice }: WithQuoteProps) => {
  const { primary } = slice;
  const { quote, submitter } = primary;

  return (
    <figure className="flow">
      <blockquote>
        <RichTextDefault content={quote} />
      </blockquote>

      <figcaption>
        <cite>{asText(submitter)}</cite>
      </figcaption>
    </figure>
  );
};
